export interface PlanningConfig {
  graphqlUrl: string;
  cognitoDomain: string;
  clientId: string;
  wsUrl: string;
  redirectUri: string;
  requiredGroup: string;
  applicationId: string;
  environment?: string;
  tenantId?: string;
  /** CloudFront origin of the gazetteer/basemap bucket. When absent the Locate step is skipped. */
  gazetteerUrl?: string;
  /** Full URL of the basemap PMTiles archive; the map falls back to a plain ground without it. */
  basemapUrl?: string;
}

let _config: PlanningConfig | null = null;

export async function loadRuntimeConfig(): Promise<void> {
  const res = await fetch('./config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Failed to load config.json: HTTP ${res.status}`);
  _config = await res.json() as PlanningConfig;
}

export function getConfig(): PlanningConfig {
  if (!_config) throw new Error('Runtime config not loaded — call loadRuntimeConfig() first');
  return _config;
}
